import { episodesActionTypes } from '@/admin/pages/studyGoBridgeEpisodes/Constants';

import type { EpisodesActions } from '@/admin/pages/studyGoBridgeEpisodes/Actions';
import type { EpisodeState } from '@/admin/pages/studyGoBridgeEpisodes/types';

const initialState: EpisodeState = {
	episodes: [],
	loading: false,
	error: null,
};

export default function episodeReducer(
	state = initialState,
	action: EpisodesActions,
): EpisodeState {
	switch (action.type) {
		case episodesActionTypes.GET_EPISODES_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case episodesActionTypes.GET_EPISODES_SUCCESS:
			return {
				...state,
				loading: false,
				episodes: action.payload.episodes,
				error: null,
			};
		case episodesActionTypes.GET_EPISODES_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error,
			};
		default:
			return state;
	}
}
